// طلبات تطبيق العملاء (فور رنت/كابري) — 2026-10-03.
const EN_B11: Record<string, string> = {
  "إرسال عرض تكلفة": "Send cost offer",
  "إضافة ملاحظة": "Add note",
  "إغلاق كمكتمل": "Close as completed",
  "التكلفة المعروضة": "Offered cost",
  "التكلفة على العميل (د.ك) — لعرض التكلفة": "Cost to the customer (KWD) — for a cost offer",
  "الخدمات المتاحة في التطبيق": "Services available in the app",
  "المؤشرات": "Metrics",
  "المحصّل من التطبيق (30 يوماً)": "Collected via the app (30 days)",
  "المدة المطلوبة": "Requested duration",
  "المسؤول": "Assignee",
  "المفتوحة": "Open",
  "بانتظار موافقة العميل": "Awaiting customer approval",
  "بحث برقم العقد أو الهاتف أو الاسم": "Search by contract, phone or name",
  "بدء المراجعة": "Start review",
  "بعد الموافقة: سجّل التمديد في Drive8 — يكتمل الطلب ويُبلَّغ العميل تلقائياً عند المزامنة.": "After approval: enter the extension in Drive8 — the request completes and the customer is notified automatically on sync.",
  "بلاغ مشكلة/حادث": "Problem / accident report",
  "تبديل السيارة": "Car swap",
  "تمت الموافقة": "Approved",
  "تمديد العقد": "Contract extension",
  "حسابات العملاء المفعّلة": "Activated customer accounts",
  "حسابات جديدة (30 يوماً)": "New accounts (30 days)",
  "داخلي": "internal",
  "رسالة تظهر للعميل (مطلوبة عند الرفض)": "Message shown to the customer (required when declining)",
  "رقم الاتصال (البدالة)": "Call number (call center)",
  "رقم البدالة (واتساب)": "Call center number (WhatsApp)",
  "رقم واتساب للتواصل": "WhatsApp contact number",
  "إيميل التواصل (يظهر في صفحة الخصوصية)": "Contact email (shown on the privacy page)",
  "روابط دفع / مدفوعة (30 يوماً)": "Payment links / paid (30 days)",
  "سجل الطلب": "Request history",
  "طلب مساعدة": "Assistance",
  "طلبات (30 يوماً)": "Requests (30 days)",
  "طلبات تطبيق العملاء": "Customer App Requests",
  "طلبات عملاء فور رنت وكابري من التطبيق — تصل صندوق الوارد أيضاً": "Requests from For Rent and Capri customers in the app — they also reach the inbox",
  "عملاء نشطون (30 يوماً)": "Active customers (30 days)",
  "غير نشط": "inactive",
  "متوسط الإغلاق (ساعة)": "Average time to close (hours)",
  "ملاحظة العميل": "Customer note",
  "ملاحظة داخلية (لا تظهر للعميل)": "Internal note (not shown to the customer)",
  "منه يُرسَل رمز الدخول للعملاء، وفيه تظهر طلباتهم في صندوق الوارد.": "Customers' sign-in codes are sent from it, and their requests appear under it in the inbox.",
  "مُستلم": "Received",
  "نسبة اكتمال التمديد (90 يوماً)": "Extension completion rate (90 days)",
  "— لم يُحدَّد (الدخول متوقف) —": "— Not set (sign-in disabled) —",
  "الشروط (إنجليزي)": "Terms (English)",
  "الشروط (عربي)": "Terms (Arabic)",
  "العرض لا يُطبَّق آلياً: يطلب العميل الاستفادة فيصل الطلب صندوق الوارد، ويطبّقه الفرع في Drive8.": "Offers aren't applied automatically: the customer requests it, the request reaches the inbox, and the branch applies it in Drive8.",
  "العروض": "Offers",
  "العنوان (إنجليزي)": "Title (English)",
  "العنوان (عربي)": "Title (Arabic)",
  "الوصف (إنجليزي)": "Description (English)",
  "الوصف (عربي)": "Description (Arabic)",
  "طلبات الاستفادة": "Redemption requests",
  "طلبات الاستفادة من العروض (30 يوماً)": "Offer redemption requests (30 days)",
  "عرض جديد": "New offer",
  "لا توجد عروض": "No offers",
  "جميع العملاء": "All customers",
  "العملاء المتكرّرون": "Repeat customers",
  "العملاء المنقطعون": "Lapsed customers",
  "مستأجرو المدد الطويلة": "Long-term renters",
  "حساب المراجعة (Apple / Google)": "Review account (Apple / Google)",
  "لمراجِع المتجر: يدخل بهذا الرقم والرمز بدون واتساب، ويرى بيانات تجريبية فقط (لا عملاء حقيقيين ولا دفع ولا صندوق الوارد). آخر ٤ أرقام من الرقم المدني: 1234. أطفئه بعد قبول التطبيق.": "For the store reviewer: signs in with this number and code without WhatsApp and sees demo data only (no real customers, payments or inbox). Last 4 digits of civil ID: 1234. Turn it off after the app is approved.",
  "رمز من ٦ أرقام": "6-digit code",
  "أقل من": "Below",
  "إجمالي المكافأة": "Total bonus",
  "اضبطه من كشف التحصيل": "Set it in the collection statement",
  "التحصيل الفعلي": "Actual collection",
  "التحصيل الفعلي والتارجت هما رقما «التحصيل» في كشف التحصيل نفسه. المكافأة = التحصيل الفعلي × نسبة الشريحة، مقسومة بالتساوي على موظفي الشهر.": "Actual collection and target are the same “collection” figures shown in the collection statement. Bonus = actual collection × tier rate, split equally among the month's staff.",
  "القائمة منقولة من شهر": "List carried over from",
  "تارجت التحصيل": "Collection target",
  "تارجت الشهر": "Monthly target",
  "تبقى القائمة للأشهر التالية حتى تغيّرها.": "The list carries over to the following months until you change it.",
  "تحقيق التارجت": "Target achievement",
  "فأكثر": "and above",
  "للوصول إلى": "to reach",
  "لم يُحدَّد موظفون — اختر موظفي القسم لتُقسم المكافأة عليهم.": "No staff selected — choose the department's staff to split the bonus among them.",
  "لم يُضبط تارجت التحصيل لهذا الشهر.": "No collection target is set for this month.",
  "مكافأة الشخص الواحد": "Bonus per person",
  "مكافأة الشخص عند بداية الشريحة": "Per-person bonus at tier start",
  "مكافأة قسم التحصيل حسب نسبة تحقيق تارجت الشهر — تُقسم بالتساوي على موظفي القسم": "Collection department bonus by monthly target achievement — split equally among the department's staff",
  "موظفو التحصيل": "Collection staff",
  "نسبة التحقيق": "Achievement",
  "نسبة المكافأة": "Bonus rate",
  "رقم المخالفة": "Violation no.",
  "تاريخ المخالفة": "Violation date",
  "نوع المخالفة": "Violation type",
  "مخالفة أخرى": "Another violation",
  "المخالفات": "Violations",
  "طلب تأجير سيارة": "Car rental request",
  "خيارات طلب التأجير": "Rental request options",
  "ما تطفئه لا يظهر للعميل في التطبيق — وتفعّله متى ما توفر.": "What you turn off is hidden from customers in the app — turn it back on when available.",
  "أنواع الإيجار": "Rental types",
  "فئات السيارات": "Car categories",
  "طرق الاستلام": "Pick-up options",
  "تأجير منتهي بالتملك": "Lease to own",
  "صالون": "Sedan",
  "جيب / SUV": "SUV",
  "فان / باص": "Van / bus",
  "فخمة": "Luxury",
  "أي سيارة متوفرة": "Any available car",
  "استلام من الفرع": "Pick up at the branch",
  "توصيل لعنواني": "Deliver to my address",
  "استلام من المطار": "Pick up at the airport",
  "عائلي": "Family",
  "صور التطبيق": "App images",
  "ارفع صورة لكل فئة وللبانر — يفضّل صورة سيارة على خلفية بيضاء. اضغط «حفظ» بعد الرفع. بلا صورة تبقى صورة التطبيق الحالية.": "Upload an image for each category and the banner — ideally a car on a white background. Press “Save” after uploading. Without an image the app keeps its built-in one.",
  "الصورة الافتراضية": "Default image",
  "رفع صورة": "Upload image",
  "صورة البانر (الرئيسية)": "Banner image (home)",
  "فئة: صالون": "Category: Sedan",
  "فئة: جيب / SUV": "Category: SUV",
  "فئة: عائلي": "Category: Family",
  "فئة: فخمة": "Category: Luxury",
  "فئة: أي سيارة متوفرة": "Category: Any available car",
};
export default EN_B11;
